(() => {
  angular
    .module('specsguardApp')
    .controller('sgExpansionPanelController', sgExpansionPanelController);

  sgExpansionPanelController.$inject = ['sgExpansionPanelFactory'];

  function sgExpansionPanelController (sgExpansionPanelFactory) {

    const vm = this;

    vm.closeAll = () => {
      sgExpansionPanelFactory.closeAll();
    };

    vm.expandPanel = (ev, writable) => {

      if (writable === 'true') {
        if (ev.currentTarget.parentNode.classList.contains('sg-expansion-panel--open')) {
          vm.closeAll();
        } else {
          vm.closeAll();
          ev.currentTarget.parentNode.classList.add('sg-expansion-panel--open');
        }
      }
    };
  }
})();
